import { moduleSelectorFactory, useTypedSelector } from 'Libs/redux/utils';
import { getLastEditor } from './selectors';

export const useModuleSelector = moduleSelectorFactory('courses');

export const useLastEditor = () => useTypedSelector(getLastEditor);
